import { HardwareFeature, ColorTheme } from "./types";

export const watchColorTheme: ColorTheme = {
    blue: {
        gradient: "from-blue-400 to-blue-600",
        rgb: "59, 130, 246",
    },
    orange: {
        gradient: "from-orange-400 to-orange-600",
        rgb: "249, 115, 22",
    },
    amber: {
        gradient: "from-amber-400 to-amber-600",
        rgb: "245, 158, 11",
    },
    slate: {
        gradient: "from-slate-400 to-slate-600",
        rgb: "100, 116, 139",
    },
    indigo: {
        gradient: "from-indigo-400 to-indigo-600",
        rgb: "99, 102, 241",
    },
    emerald: {
        gradient: "from-emerald-400 to-emerald-600",
        rgb: "52, 211, 153",
    },
    red: {
        gradient: "from-red-400 to-red-600",
        rgb: "239, 68, 68",
    },
    rose: {
        gradient: "from-rose-400 to-rose-600",
        rgb: "251, 113, 133",
    },
    violet: {
        gradient: "from-violet-400 to-violet-600",
        rgb: "139, 92, 246",
    },
};

export const WatchHardwareFeatures: HardwareFeature[] = [
    {
        image: "../media/Hardware feature/watch/Frame 66.webp",
        className: "col-span-12 md:col-span-4 row-span-1 md:row-span-3",
        color: "blue",
    },
    {
        image: "../media/Hardware feature/watch/Frame 63.webp",
        className: "col-span-12 md:col-span-4 row-span-1 md:row-span-2 md:col-start-1 md:row-start-4",
        color: "orange",
    },
    {
        image: "../media/Hardware feature/watch/Frame 53.webp",
        className: "col-span-12 md:col-span-4 row-span-1 md:row-span-5 md:col-start-5 md:row-start-1",
        color: "amber",
    },
    {
        image: "../media/Hardware feature/watch/Frame 64.webp",
        className: "col-span-12 md:col-span-2 row-span-1 md:row-span-2 md:col-start-9 md:row-start-1",
        color: "blue",
    },
    {
        image: "../media/Hardware feature/watch/Frame 59.webp",
        className: "col-span-12 md:col-span-2 row-span-1 md:row-span-2 md:col-start-11 md:row-start-1",
        color: "red",
    },
    {
        image: "../media/Hardware feature/watch/Frame 67.webp",
        className: "col-span-12 md:col-span-4 row-span-1 md:row-span-3 md:col-start-9 md:row-start-3",
        color: "emerald",
    },
];